<div fxLayout="column" fxFlex style=" height:100vh; justify-content:center; align-items:center;">
    <a routerLink="/">
        <img class="logo" src="../../../assets/images/defaultImage.png" alt="">
    </a>
    <h1 class="h-1">404</h1>
    <h3 class="h-3">Page Not Found</h3>
    <p>Looks like you are wandering around a lost alley.</p>
    <a class="link c-p link-g mt-3" routerLink="/"><i class="fas fa-long-arrow-left mr-1"></i> Back to home</a>
</div>